import { gql } from 'urql'

const QueryCareersSetting = gql`
  query {
    tenantSettingsCareerSite
  }
`

export default QueryCareersSetting
